import React from "react";
import { Card } from "antd";

const colorMap = {
  blue: "bg-blue-50 dark:bg-blue-900/20",
  red: "bg-red-50 dark:bg-red-900/20",
  emerald: "bg-emerald-50 dark:bg-emerald-900/20",
  orange: "bg-orange-50 dark:bg-orange-900/20",
};

const FrameworkSection = ({ icon: Icon, color, title, description, categories }) => (
  <Card className={`p-2 mx-4 rounded-xl card-border dark:bg-white/5 ${color}`}>
    <div className="items-start gap-1.5">
      <div className="flex items-center gap-1">
        <Icon className={`icon-color ${color} h-5 w-5`} />
        <h4 className="flex text-[16px] dark:text-white">{title}</h4>
      </div>
      <p className="text-gray-700 dark:text-gray-200">{description}</p>
    </div>

    {categories.map(({ title: catTitle, items }) => (
      <div key={catTitle} className="mt-3 space-y-1">
        <p className="font-semibold text-[14px] dark:text-white">{catTitle}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {items.map(({ label, color, text }) => (
            <div
              key={label}
              className={`p-2 rounded border ${colorMap[color] }`}
            >
              <p
                className={`text-[11px] font-medium label-color ${label
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`}
              >
                {label}
              </p>
              <p className="text-[11px] dark:text-white">{text}</p>
            </div>
          ))}
        </div>
      </div>
    ))}
  </Card>
);

export default FrameworkSection;